import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectNewbuildingsCompareBlocks, selectNewbuildingsComparison } from '../../selectors/newbuildingsCompare';
import { INewbuildingSummaryRow, TNewbuildingsCompareRow } from '../../types/newbuildingsCompare';
import { TNewbuildingsCompareViewRow, NewbuildingsComparePage } from '../../components/NewbuildingsComparePage';
import { Cell } from '../../components/NewbuildingsComparePage/parts/Cell';

function isNewbuildingSummaryRow(row: TNewbuildingsCompareRow): row is INewbuildingSummaryRow {
  return row.type === 'newbuildingSummary';
}

export const NewbuildingsComparePageContainer = () => {
  const comparison = useSelector(selectNewbuildingsComparison);
  const blocks = useSelector(selectNewbuildingsCompareBlocks);

  if (!comparison) {
    return null;
  }

  const summaryRow = blocks.flatMap(block => block.rows).find(isNewbuildingSummaryRow);
  const headers = [
    '',
    ...(summaryRow?.cells.map((cell, index) => <Cell cell={cell} key={index} type={summaryRow.type} />) ?? []),
  ];
  const floatingHeaders = [
    '',
    ...(summaryRow?.cells.map((cell, index) => <Cell cell={cell} floating key={index} type={summaryRow.type} />) ?? []),
  ];

  const tableRows = blocks.flatMap<TNewbuildingsCompareViewRow>((block, blockIndex) => {
    const dataRows = block.rows
      .filter(row => !isNewbuildingSummaryRow(row))
      .map<TNewbuildingsCompareViewRow>((row, rowIndex) => ({
        cells: row.cells.map((cell, index) => <Cell cell={cell} key={index} type={row.type} />),
        key: `${blockIndex}-${row.type}-${row.title ?? rowIndex}`,
        kind: 'data',
        title: row.title,
      }));

    if (block.title) {
      return [{ key: `block-${blockIndex}`, kind: 'block', title: block.title }, ...dataRows];
    }

    return dataRows;
  });

  return (
    <NewbuildingsComparePage
      floatingHeaders={floatingHeaders}
      headers={headers}
      rows={tableRows}
      title={comparison.title}
    />
  );
};
